export const isSimilarUrl = (url1, url2, config) => {

  if (url1 === url2) {
    return true
  }
  if(config.base){
    url1 = url1.replace(config.base, '')
    url2 = url2.replace(config.base, '')
  }
  if(config.patterns){
    for(const pattern of config.patterns){
      if(url1.match(pattern) && url2.match(pattern)){
        return true
      }
    }
  }
  return false
}
export default isSimilarUrl;